import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const buttonsWrapper = css`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 0.75rem;
`;

export const overrideButtonWrapper = css`
  grid-template-columns: 1fr;
  @media screen and (max-width: ${dimensions.tabletMax}) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const singleActionButton = css`
  @media screen and (max-width: ${dimensions.tabletMax}) {
    grid-template-columns: 1fr;
  }
`;

export const fullWidth = css`
  width: 100%;
`;

export const container = css`
  > :empty {
    display: none;
  }
`;

// TODO: Remove this after implementing LARGE version of QuantitySelector
export const quantitySelectorButton = css`
  > * {
    height: 3.5rem !important;
  }
`;
